<template>
  <div class="pos-cart flex-grow-1 d-flex flex-column overflow-hidden">
     <div class="pa-4 border-bottom d-flex align-center justify-space-between">
      <h2 class="text-h6 font-weight-bold grey--text text--darken-2">
        <v-icon class="mr-1">{{ icons.mdiBasket }}</v-icon> Carrinho
      </h2>
      <v-chip color="primary" small class="font-weight-bold">
        {{ items.length }} Itens
      </v-chip>
    </div>

    <div class="flex-grow-1 overflow-y-auto pa-2">
       <div v-if="items.length === 0" class="d-flex flex-column align-center justify-center fill-height opacity-60">
          <v-icon size="64" color="grey lighten-2">{{ icons.mdiCartOutline }}</v-icon>
          <span class="text-body-2 grey--text mt-2">Carrinho vazio</span>
       </div>

       <v-list v-else two-line dense class="pa-0">
          <v-list-item v-for="(item, index) in items" :key="item.id" class="mb-2 rounded-lg grey lighten-5">
             <v-list-item-avatar tile size="40" color="white" class="rounded">
                <v-icon color="grey lighten-1">{{ icons.mdiCubeOutline }}</v-icon>
             </v-list-item-avatar>
             
             <v-list-item-content>
               <v-list-item-title class="font-weight-medium text-body-2">{{ item.name }}</v-list-item-title>
               <v-list-item-subtitle class="caption">
                 {{ (item.price / 100) | moneyBr }} un
               </v-list-item-subtitle>
             </v-list-item-content>

             <v-list-item-action class="d-flex flex-row align-center ma-0">
                <v-btn icon x-small class="grey lighten-3" @click="$emit('update-qty', { item, qty: item.qty - 1 })">
                  <v-icon x-small>{{ icons.mdiMinus }}</v-icon>
                </v-btn>
                <span class="mx-3 font-weight-bold body-2">{{ item.qty }}</span>
                <v-btn icon x-small class="primary lighten-4 primary--text" @click="$emit('update-qty', { item, qty: item.qty + 1 })">
                  <v-icon x-small>{{ icons.mdiPlus }}</v-icon>
                </v-btn>
                
                <div class="ml-4 font-weight-bold text-body-2 text-right" style="min-width: 70px;">
                   {{ ((item.price * item.qty) / 100) | moneyBr }}
                </div>
                
                <v-btn icon small color="grey lighten-1" class="ml-1" @click="$emit('remove', item)">
                   <v-icon small>{{ icons.mdiClose }}</v-icon>
                </v-btn>
             </v-list-item-action>
          </v-list-item>
       </v-list>
    </div>
  </div>
</template>

<script>
import { mdiBasket, mdiCartOutline, mdiCubeOutline, mdiMinus, mdiPlus, mdiClose } from '@mdi/js';

export default {
  name: "POSCart",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
      return {
          icons: {
              mdiBasket, mdiCartOutline, mdiCubeOutline, mdiMinus, mdiPlus, mdiClose
          }
      }
  }
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #eee;
}
</style>
